import { render, staticRenderFns } from "./EstimationSameDay.vue?vue&type=template&id=5b06a7a6&scoped=true"
import script from "./EstimationSameDay.vue?vue&type=script&lang=js"
export * from "./EstimationSameDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06a7a6",
  null
  
)

export default component.exports